import React from 'react';
import {Noun, Nationality, Pronoun} from '../model/Helper';
/**
 * 
 * @param {Array} props accepts party and type 
 */
const PaperParty = (props)=>{
    let blankLine = "____________________";
    let party = props.party;
    let type = props.type;
    
    let nounParty = Noun(props.party, props.type);

    let legalPersonality=[], name=[], spouseName=[], nationality=[], maritalStatus=[], address=[], hasRepresentative=[], representativeName=[], representativeNationality=[], representativeAddress=[];
    let corporationName=[], corporationAddress=[], corporationRepresentativeName=[], corporationRepresentativePosition=[], gender=[];

    if(type==="seller"){
        party.forEach((p, i)=>{
            legalPersonality[i] = p.legalPersonality;

            name[i] = (p.sellerFname || p.sellerMname || p.sellerLname) ? 
            (p.sellerFname+(p.sellerMname?` ${p.sellerMname}`:"")+(p.sellerLname?` ${p.sellerLname}`:"")+(p.sellerSuffix?` ${p.sellerSuffix}`:"")): 
            blankLine;

            gender[i] = p.sellerGender;

            maritalStatus[i] = p.sellerMaritalStatus;

            spouseName[i] = (p.sellerSpouseFname || p.sellerSpouseMname || p.sellerSpouseLname) ? 
            (p.sellerSpouseFname+(p.sellerSpouseMname?` ${p.sellerSpouseMname}`:"")+(p.sellerSpouseLname?` ${p.sellerSpouseLname}`:"")+(p.sellerSpouseSuffix?` ${p.sellerSpouseSuffix}`:"")): 
            blankLine; 

            nationality[i] = p.sellerNationality || blankLine;

            address[i] = p.sellerAddress || blankLine;

            hasRepresentative[i] = p.sellerHasRepresentative || blankLine;

            representativeName[i] = (p.sellerRepresentativeFname || p.sellerRepresentativeMname || p.sellerRepresentativeLname) ? 
            (p.sellerRepresentativeFname+(p.sellerRepresentativeMname?` ${p.sellerRepresentativeMname}`:"")+(p.sellerRepresentativeLname?` ${p.sellerRepresentativeLname}`:"")+(p.sellerRepresentativeSuffix?` ${p.sellerRepresentativeSuffix}`:"")): 
            blankLine;

            representativeNationality[i] = p.sellerRepresentativeNationality || blankLine;

            representativeAddress[i] = p.sellerRepresentativeAddress || blankLine;

            corporationName[i] = p.sellerCorporationName || blankLine;
            
            corporationAddress[i] = p.sellerCorporationPrincipalPlaceOfBusiness?        p.sellerCorporationPrincipalPlaceOfBusiness:blankLine;

            corporationRepresentativeName[i] = (p.sellerCorporationRepresentativeFname || p.sellerCorporationRepresentativeMname || p.sellerCorporationRepresentativeLname) ? 
            (p.sellerCorporationRepresentativeFname+(p.sellerCorporationRepresentativeMname?` ${p.sellerCorporationRepresentativeMname}`:"")+(p.sellerCorporationRepresentativeLname?` ${p.sellerCorporationRepresentativeLname}`:"")+(p.sellerCorporationRepresentativeSuffix?` ${p.sellerCorporationRepresentativeSuffix}`:"")): 
            blankLine;

            corporationRepresentativePosition[i] = p.sellerCorporationRepresentativePosition?p.sellerCorporationRepresentativePosition:blankLine
        })
    }

    if(type==="buyer"){
        party.forEach((p, i)=>{
            legalPersonality[i] = p.legalPersonality;

            name[i] = (p.buyerFname || p.buyerMname || p.buyerLname) ? 
            (p.buyerFname+(p.buyerMname?` ${p.buyerMname}`:"")+(p.buyerLname?` ${p.buyerLname}`:"")+(p.buyerSuffix?` ${p.buyerSuffix}`:"")): 
            blankLine;

            gender[i] = p.buyerGender;

            maritalStatus[i] = p.buyerMaritalStatus;

            spouseName[i] = (p.buyerSpouseFname || p.buyerSpouseMname || p.buyerSpouseLname) ? 
            (p.buyerSpouseFname+(p.buyerSpouseMname?` ${p.buyerSpouseMname}`:"")+(p.buyerSpouseLname?` ${p.buyerSpouseLname}`:"")+(p.buyerSpouseSuffix?` ${p.buyerSpouseSuffix}`:"")): 
            blankLine; 

            nationality[i] = p.buyerNationality || blankLine;

            address[i] = p.buyerAddress || blankLine;

            hasRepresentative[i] = p.buyerHasRepresentative || blankLine;

            representativeName[i] = (p.buyerRepresentativeFname || p.buyerRepresentativeMname || p.buyerRepresentativeLname) ? 
            (p.buyerRepresentativeFname+(p.buyerRepresentativeMname?` ${p.buyerRepresentativeMname}`:"")+(p.buyerRepresentativeLname?` ${p.buyerRepresentativeLname}`:"")+(p.buyerRepresentativeSuffix?` ${p.buyerRepresentativeSuffix}`:"")): 
            blankLine;

            representativeNationality[i] = p.buyerRepresentativeNationality || blankLine;

            representativeAddress[i] = p.buyerRepresentativeAddress || blankLine;

            corporationName[i] = p.buyerCorporationName || blankLine;
            
            corporationAddress[i] = p.buyerCorporationPrincipalPlaceOfBusiness?        p.buyerCorporationPrincipalPlaceOfBusiness:blankLine;

            corporationRepresentativeName[i] = (p.buyerCorporationRepresentativeFname || p.buyerCorporationRepresentativeMname || p.buyerCorporationRepresentativeLname) ? 
            (p.buyerCorporationRepresentativeFname+(p.buyerCorporationRepresentativeMname?` ${p.buyerCorporationRepresentativeMname}`:"")+(p.buyerCorporationRepresentativeLname?` ${p.buyerCorporationRepresentativeLname}`:"")+(p.buyerCorporationRepresentativeSuffix?` ${p.buyerCorporationRepresentativeSuffix}`:"")): 
            blankLine;

            corporationRepresentativePosition[i] = p.buyerCorporationRepresentativePosition?p.buyerCorporationRepresentativePosition:blankLine
        })
    }

    if(type==="mortgagor"){
        party.forEach((p, i)=>{
            legalPersonality[i] = p.legalPersonality;

            name[i] = (p.mortgagorFname || p.mortgagorMname || p.mortgagorLname) ? 
            (p.mortgagorFname+(p.mortgagorMname?` ${p.mortgagorMname}`:"")+(p.mortgagorLname?` ${p.mortgagorLname}`:"")+(p.mortgagorSuffix?` ${p.mortgagorSuffix}`:"")): 
            blankLine;

            gender[i] = p.mortgagorGender;

            maritalStatus[i] = p.mortgagorMaritalStatus;

            spouseName[i] = (p.mortgagorSpouseFname || p.mortgagorSpouseMname || p.mortgagorSpouseLname) ? 
            (p.mortgagorSpouseFname+(p.mortgagorSpouseMname?` ${p.mortgagorSpouseMname}`:"")+(p.mortgagorSpouseLname?` ${p.mortgagorSpouseLname}`:"")+(p.mortgagorSpouseSuffix?` ${p.mortgagorSpouseSuffix}`:"")): 
            blankLine; 

            nationality[i] = p.mortgagorNationality || blankLine;

            address[i] = p.mortgagorAddress || blankLine;

            hasRepresentative[i] = p.mortgagorHasRepresentative || blankLine;

            representativeName[i] = (p.mortgagorRepresentativeFname || p.mortgagorRepresentativeMname || p.mortgagorRepresentativeLname) ? 
            (p.mortgagorRepresentativeFname+(p.mortgagorRepresentativeMname?` ${p.mortgagorRepresentativeMname}`:"")+(p.mortgagorRepresentativeLname?` ${p.mortgagorRepresentativeLname}`:"")+(p.mortgagorRepresentativeSuffix?` ${p.mortgagorRepresentativeSuffix}`:"")): 
            blankLine;

            representativeNationality[i] = p.mortgagorRepresentativeNationality || blankLine;

            representativeAddress[i] = p.mortgagorRepresentativeAddress || blankLine;

            corporationName[i] = p.mortgagorCorporationName || blankLine;
            
            corporationAddress[i] = p.mortgagorCorporationPrincipalPlaceOfBusiness?        p.mortgagorCorporationPrincipalPlaceOfBusiness:blankLine;

            corporationRepresentativeName[i] = (p.mortgagorCorporationRepresentativeFname || p.mortgagorCorporationRepresentativeMname || p.mortgagorCorporationRepresentativeLname) ? 
            (p.mortgagorCorporationRepresentativeFname+(p.mortgagorCorporationRepresentativeMname?` ${p.mortgagorCorporationRepresentativeMname}`:"")+(p.mortgagorCorporationRepresentativeLname?` ${p.mortgagorCorporationRepresentativeLname}`:"")+(p.mortgagorCorporationRepresentativeSuffix?` ${p.mortgagorCorporationRepresentativeSuffix}`:"")): 
            blankLine;

            corporationRepresentativePosition[i] = p.mortgagorCorporationRepresentativePosition?p.mortgagorCorporationRepresentativePosition:blankLine
        })
    }

    if(type==="mortgagee"){
        party.forEach((p, i)=>{
            legalPersonality[i] = p.legalPersonality;

            name[i] = (p.mortgageeFname || p.mortgageeMname || p.mortgageeLname) ? 
            (p.mortgageeFname+(p.mortgageeMname?` ${p.mortgageeMname}`:"")+(p.mortgageeLname?` ${p.mortgageeLname}`:"")+(p.mortgageeSuffix?` ${p.mortgageeSuffix}`:"")): 
            blankLine;

            gender[i] = p.mortgageeGender;

            maritalStatus[i] = p.mortgageeMaritalStatus;

            spouseName[i] = (p.mortgageeSpouseFname || p.mortgageeSpouseMname || p.mortgageeSpouseLname) ? 
            (p.mortgageeSpouseFname+(p.mortgageeSpouseMname?` ${p.mortgageeSpouseMname}`:"")+(p.mortgageeSpouseLname?` ${p.mortgageeSpouseLname}`:"")+(p.mortgageeSpouseSuffix?` ${p.mortgageeSpouseSuffix}`:"")): 
            blankLine; 

            nationality[i] = p.mortgageeNationality || blankLine;

            address[i] = p.mortgageeAddress || blankLine;

            hasRepresentative[i] = p.mortgageeHasRepresentative || blankLine;

            representativeName[i] = (p.mortgageeRepresentativeFname || p.mortgageeRepresentativeMname || p.mortgageeRepresentativeLname) ? 
            (p.mortgageeRepresentativeFname+(p.mortgageeRepresentativeMname?` ${p.mortgageeRepresentativeMname}`:"")+(p.mortgageeRepresentativeLname?` ${p.mortgageeRepresentativeLname}`:"")+(p.mortgageeRepresentativeSuffix?` ${p.mortgageeRepresentativeSuffix}`:"")): 
            blankLine;

            representativeNationality[i] = p.mortgageeRepresentativeNationality || blankLine;

            representativeAddress[i] = p.mortgageeRepresentativeAddress || blankLine;

            corporationName[i] = p.mortgageeCorporationName || blankLine;
            
            corporationAddress[i] = p.mortgageeCorporationPrincipalPlaceOfBusiness?        p.mortgageeCorporationPrincipalPlaceOfBusiness:blankLine;

            corporationRepresentativeName[i] = (p.mortgageeCorporationRepresentativeFname || p.mortgageeCorporationRepresentativeMname || p.mortgageeCorporationRepresentativeLname) ? 
            (p.mortgageeCorporationRepresentativeFname+(p.mortgageeCorporationRepresentativeMname?` ${p.mortgageeCorporationRepresentativeMname}`:"")+(p.mortgageeCorporationRepresentativeLname?` ${p.mortgageeCorporationRepresentativeLname}`:"")+(p.mortgageeCorporationRepresentativeSuffix?` ${p.mortgageeCorporationRepresentativeSuffix}`:"")): 
            blankLine;

            corporationRepresentativePosition[i] = p.mortgageeCorporationRepresentativePosition?p.mortgageeCorporationRepresentativePosition:blankLine
        })
    }

    return(
        <div className={`paper-narrow`}>
            <div>
                {
                    party.map((p, i)=>{
                        
                        if(legalPersonality[i]===`Natural Person`){
                            return(
                                <span className={`no-indent ${type}_legalPersonality-${i} ${type}_${type}MaritalStatus-${i} ${type}_${type}HasRepresentative-${i}`} key={i}>

                                    {i>0 && i!==i.length-1?<span>; </span>:""}
                                    
                                    {maritalStatus[i]===`Married`?<span className={`dynamic-data font-weight-bold ${type}_${type}MaritalStatus-${i}`}>SPOUSES &nbsp;</span>:``}

                                    <span className={`dynamic-data text-uppercase font-weight-bold ${type}_${type}Fname-${i} ${type}_${type}Mname-${i} ${type}_${type}Lname-${i} ${type}_${type}Suffix-${i} ${type}_${type}Gender-${i}`}>{name[i]}</span>

                                    {maritalStatus[i]===`Married`?<span className={`dynamic-data font-weight-bold text-uppercase ${type}_${type}SpouseFname-${i} ${type}_${type}SpouseMname-${i} ${type}_${type}SpouseLname-${i} ${type}_${type}SpouseSuffix-${i}`}> <span className="text-lowercase">and</span> {spouseName[i]}</span>:``}, <span className={`dynamic-data text-capitalize ${type}_${type}Nationality-${i}`}>{Nationality(nationality[i], maritalStatus[i])}</span>, {maritalStatus[i]===`Married`?`both `:``}of legal age, with address at <span className={`dynamic-data text-capitalize ${type}_${type}Address-${i}`}>{address[i]}</span>

                                    <span className={hasRepresentative[i]===`Yes`?``:`d-none`}>
                                    , represented herein by {Pronoun("his", gender[i], legalPersonality[i], nounParty)} attorney-in-fact, <span className={`dynamic-data text-uppercase font-weight-bold ${type}_${type}RepresentativeFname-${i} ${type}_${type}RepresentativeMname-${i} ${type}_${type}RepresentativeLname-${i} ${type}_${type}RepresentativeSuffix-${i} ${type}_${type}RepresentativeGender-${i}`}>{representativeName[i]}</span>, <span className={`dynamic-data text-capitalize ${type}_${type}RepresentativeNationality-${i}`}>{representativeNationality[i]}</span>, of legal age, with address at <span className={`dynamic-data text-capitalize ${type}_${type}RepresentativeAddress-${i}`}>{representativeAddress[i]}</span><span className={`dynamic-data ${type==="seller"?``:`d-none`}`}>, whose Special Power of Attorney is attached hereto</span>
                                    </span>
                                </span>
                            )
                        } else {
                            return(
                                <span key={i}>

                                    {i>0 && i!==i.length-1?<span>; </span>:""}

                                    <span className={`dynamic-data text-uppercase font-weight-bold ${type}_${type}CorporationName-${i}`}>{corporationName[i]}</span>, a corporation duly organized and existing under and by virtue of the laws of the Republic of the Philippines, with principal business address at <span className={`dynamic-data text-capitalize ${type}_${type}CorporationPrincipalPlaceOfBusiness-${i}`}>{corporationAddress[i]}</span>, and represented herein by its <span className={`dynamic-data text-capitalize ${type}_${type}CorporationRepresentativePosition-${i}`}>{corporationRepresentativePosition[i]}</span>, <span className={`dynamic-data text-uppercase font-weight-bold ${type}_${type}CorporationRepresentativeFname-${i} ${type}_${type}CorporationRepresentativeMname-${i} ${type}_${type}CorporationRepresentativeLname-${i} ${type}_${type}CorporationRepresentativeSuffix-${i}`}>{corporationRepresentativeName[i]}</span>, via authorization by the Board of Directors as evinced by the Secretary's Certificate attached hereto

                                </span> 
                            )
                        }
                    })   
                }, hereinafter referred to as the <span className={`font-weight-bold text-uppercase`}>"{nounParty}"</span>{type==="seller" || type==="mortgagor"?";":"."}
            </div>
        </div>
    )
}

export default PaperParty;


// WEBPACK FOOTER //
// ./src/view/PaperParty.js